import { useNotify, useRecordContext } from 'react-admin';
import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';
import client from '../../../data/api';
import CraftDeleteButtonWithConfirmation from '../../../components/CraftDeleteButtonWithConfirmation';

export const DeleteButton = ({ refresh }: { refresh: () => void }) => {
  const notify = useNotify();
  const record = useRecordContext();

  const [deleteCompanyCommodityMappingOld, { loading: loadingOld }] = useMutation(
    gql`
      mutation deleteCompanyCommoditiesMappingOld($id: bigint!) {
        signals_delete_company_commodities_by_pk(id: $id) {
          id
        }
      }
    `,
    {
      client,
      errorPolicy: 'all',
    },
  );

  const [deleteCompanyCommodityMapping, { loading }] = useMutation(
    gql`
      mutation deleteCompanyCommoditiesMapping($id: ID!) {
        alertsDeleteCommodityCompanyMapping(id: $id) {
          ... on AlertsServiceAlertsCommodityCompanyMapping {
            id
            commodity {
              alertsTopicName
              id
              name
            }
            company {
              name
              id
              alertsTopicName
            }
          }
          ... on AlertsServiceInvalidIdError {
            message
          }
          ... on AlertsServiceNotFoundError {
            message
          }
        }
      }
    `,
    {
      client,
      errorPolicy: 'all',
    },
  );
  const handleDelete = async () => {
    const { errors, data } = await deleteCompanyCommodityMapping({
      variables: {
        id: record?.id,
      },
    });

    const realData = data.alertsDeleteCommodityCompanyMapping;

    if (errors || realData.__typename !== 'AlertsServiceAlertsCommodityCompanyMapping') {
      notify(errors?.[0]?.message || realData?.message, { type: 'error' });
      return null;
    }

    await deleteCompanyCommodityMappingOld({
      variables: {
        id: record?.id,
      },
    });

    notify('Company commodity deleted', { type: 'success' });
    return refresh();
  };

  return (
    <CraftDeleteButtonWithConfirmation
      onDelete={handleDelete}
      loading={loading || loadingOld}
      title={`Delete company commodity #${record && record.id}`}
      content="Are you sure you want to delete this item?"
    />
  );
};

export default DeleteButton;
